/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

export default asciiToArray;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_asciiToArray.js
// module id = 2202
// module chunks = 67